export default __webpack_public_path__ + "static/media/button-send.60be4450.svg";